<template>
	<div id="datenschutz" class='page'>

		<div class="page-content">
			
			<h1>{{p.headline}}</h1>
			<p v-html='p.text'>
				
			</p>
		</div>

	</div>
</template>
<script>
	export default {
		name: 'datenschutz',
		components: {
			
		},
		props: {
			langsufix: String,
			content: Object
		},		
		data() {
			return {
				p: {} 
			}
		},
		created () {
			this.getContent();
		},  		
		methods: {
            scrollToTop() {
                     window.scrollTo(0,0);
            },
			close () {
				this.$router.push('/'); 
			},
			getContent () {
				this.$prismic.client.getByUID('page-short','datenschutz-'+this.langsufix)
				.then((document) => {
					console.log(document.data);
					this.p = document.data;
				})
			},   
		}
	}	
</script>

<style lang='less' scoped> 
@import '../less/variables.less';
.page-content {
	width:80%;
	min-height: 800px;
	background-color: white;
	text-align: left;
	color: @g1;
	.fm(12px);
	padding: 100px 10%;

}
h1 {
	.fmb(40px);
	color: @g1;
}
p {
	.fm(12px);
	color: @g1;	
}
.page {
	margin-top: 200px;
}
.bg {
	background-image: url('/images/bg_home.jpg'); 
} 
.page-content {
	// width: 50%; 

}

</style>